const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.3046 7.5H11.2498C11.0197 7.5 10.8332 7.31345 10.8332 7.08333V2.00116C10.8332 1.5889 10.2985 1.42702 10.0698 1.77003L3.34837 11.8522C3.16377 12.1291 3.36226 12.5 3.69505 12.5H8.74984C8.97995 12.5 9.1665 12.6865 9.1665 12.9167V17.9988C9.1665 18.4111 9.70118 18.573 9.92986 18.23L16.6513 8.14779C16.8359 7.87089 16.6374 7.5 16.3046 7.5Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
